import { createRoutine } from 'redux-saga-routines';
import { ALL_LIST } from './types';

// eslint-disable-next-line import-x/prefer-default-export
export const allList = createRoutine(ALL_LIST);
